import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Star({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Star.Outline {...props} /> : <Star.Solid {...props} />;
}

Star.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9417 1.8982L12.7691 5.54895C12.9482 5.90735 13.2939 6.15587 13.6948 6.21337L17.7827 6.80181C18.7928 6.94763 19.1947 8.17174 18.4637 8.87313L15.5076 11.7136C15.2171 11.993 15.0848 12.3945 15.1536 12.7888L15.8512 16.799C16.023 17.791 14.9672 18.5479 14.0644 18.0786L10.4106 16.1839C10.0524 15.998 9.62342 15.998 9.26419 16.1839L5.61041 18.0786C4.70763 18.5479 3.6518 17.791 3.82465 16.799L4.52125 12.7888C4.58997 12.3945 4.45773 11.993 4.16722 11.7136L1.21108 8.87313C0.480118 8.17174 0.882044 6.94763 1.89207 6.80181L5.98005 6.21337C6.38094 6.15587 6.72768 5.90735 6.90678 5.54895L8.73315 1.8982C9.18505 0.995523 10.4898 0.995523 10.9417 1.8982Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Star.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M11.3249 0.834805L13.5514 5.30908C13.7154 5.63325 14.0285 5.85836 14.3896 5.90839L19.3907 6.63676C19.6827 6.67778 19.9478 6.83185 20.1268 7.06697C20.3039 7.29909 20.3799 7.59324 20.3369 7.88239C20.3019 8.12251 20.1888 8.34462 20.0158 8.51471L16.392 12.0275C16.127 12.2726 16.0069 12.6358 16.071 12.991L16.9631 17.9295C17.0582 18.5258 16.6631 19.0881 16.071 19.2011C15.8269 19.2402 15.5768 19.1991 15.3568 19.0871L10.8958 16.7629C10.5648 16.5958 10.1737 16.5958 9.84262 16.7629L5.38166 19.0871C4.83354 19.3782 4.1544 19.1801 3.84933 18.6399C3.73631 18.4247 3.6963 18.1796 3.7333 17.9405L4.6255 13.001C4.68951 12.6468 4.56848 12.2816 4.30443 12.0365L0.68065 8.52572C0.249557 8.1095 0.236554 7.42416 0.651643 6.99294C0.660645 6.98393 0.670647 6.97393 0.68065 6.96392C0.852686 6.78883 1.07873 6.67778 1.32279 6.64876L6.32386 5.91939C6.68394 5.86836 6.99701 5.64525 7.16204 5.31909L9.3085 0.834805C9.49954 0.45061 9.89563 0.211489 10.3257 0.221494H10.4597C10.8328 0.266517 11.1579 0.497634 11.3249 0.834805Z"
          className="icon-secondary"
        />
        <path
          d="M10.3406 16.6383C10.1469 16.6443 9.95824 16.6964 9.7885 16.7894L5.34935 19.1083C4.80619 19.3675 4.1562 19.1664 3.85167 18.647C3.73884 18.4348 3.6979 18.1916 3.73585 17.9534L4.62248 13.0243C4.68238 12.6661 4.56257 12.3018 4.30197 12.0495L0.67657 8.53967C0.246235 8.11832 0.238247 7.42676 0.659596 6.9954C0.665587 6.9894 0.670579 6.98439 0.67657 6.97939C0.848305 6.80925 1.06996 6.69716 1.30859 6.66213L6.31386 5.92552C6.6763 5.87949 6.99082 5.6533 7.15057 5.32503L9.32621 0.78431C9.53289 0.418009 9.92928 0.19983 10.3486 0.222849C10.3406 0.520093 10.3406 16.4361 10.3406 16.6383Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
